import React from "react";
import {Waypoint} from "./WaypointComponent";

interface WaypointSummaryProps {
    waypoint: Waypoint
}

const WaypointSummary = (props: WaypointSummaryProps) => {

    const { waypoint } = props;

    return (
        <span>{waypoint.companyName ?? waypoint.address?.suburb}</span>
    )

}

export default WaypointSummary;
